import React from 'react';
import PropTypes from 'prop-types';
import HitRating from '../../components/Hit/HitSubComponents/HitRating/HitRating.js';
import HitPrice from '../../components/Hit/HitSubComponents/HitPrice/HitPrice';
import {SVGIcon} from '@homeaway/react-svg';
import {INSTANT_BOOK__16} from '@homeaway/svg-defs';
import './hit-footer.less';

function HitFooter(props) {
    const {
        arrivalDate,
        averageRating,
        changeSummary,
        currencyUnits,
        departureDate,
        instantBookable,
        instantBookableTooltip,
        noPrice,
        notifyChange,
        rate,
        ratesUnitOfMeasure,
        edapEventJson,
        reviewCount,
        status,
        unit
    } = props;

    return (
        <div className="card__footer scratchpad-hit-footer card__swap-reviews-price">
            <HitRating
                averageRating={averageRating}
                reviewCount={reviewCount}
            />
            <div className="price-wrapper">
                {instantBookable && (
                    <div className="price-wrapper__instantBook" title={instantBookableTooltip}>
                        <SVGIcon markup={INSTANT_BOOK__16} />
                    </div>
                )}
                <HitPrice
                    arrivalDate={arrivalDate}
                    departureDate={departureDate}
                    changeSummary={changeSummary}
                    currency={currencyUnits}
                    noPrice={noPrice}
                    notifyChange={notifyChange}
                    rate={rate}
                    ratesUnitOfMeasure={ratesUnitOfMeasure}
                    edapEventJson={edapEventJson}
                    status={status}
                    unit={unit}
                />
            </div>
        </div>
    );
}

HitFooter.propTypes = {
    averageRating: PropTypes.number,
    changeSummary: PropTypes.object,  /* eslint react/forbid-prop-types: 0 */
    noPrice: PropTypes.string,
    notifyChange: PropTypes.bool,
    rate: PropTypes.string,
    ratesUnitOfMeasure: PropTypes.string,
    edapEventJson: PropTypes.string,
    reviewCount: PropTypes.number,
    status: PropTypes.string
};

export default HitFooter;



// WEBPACK FOOTER //
// ./src/universal/abacus/swap-reviews-price/hit-footer.js